import React, { useState, useEffect } from 'react';
import { useAuth } from '../../AuthContext';
import { useNavigate } from 'react-router-dom';
import mainBackground from '../../images/Main.png';
import { FaUser, FaBell, FaEnvelope } from 'react-icons/fa';

const CustomerDashboard = () => {
    const { logout } = useAuth();
    const navigate = useNavigate();

    const [isDropdownOpen, setDropdownOpen] = useState(false);
    const [customer, setCustomer] = useState(null);
    const [error, setError] = useState(null);
    const [showCookies, setShowCookies] = useState(true);
    const [showModal, setShowModal] = useState(false); // State for modal

    useEffect(() => {
        const fetchCustomerProfile = async () => {
            const email = localStorage.getItem('customerEmail');
            if (!email) {
                console.error('No email found in local storage');
                setError('No email found. Please log in again.');
                return;
            }

            try {
                const response = await fetch('https://backend.rethinkpack.com/api/allCustomers');
                if (!response.ok) {
                    setError(response.status === 404 ? 'Customer not found' : 'Error fetching profile data');
                    return;
                }

                const allCustomers = await response.json();
                const foundCustomer = allCustomers.find((cust) => cust.email === email);
                if (foundCustomer) {
                    setCustomer(foundCustomer);
                } else {
                    setError('Customer not found');
                }
            } catch (err) {
                console.error('Fetch error:', err);
                setError('Could not load profile data');
            }
        };

        fetchCustomerProfile();
    }, []);

    const handleLogout = () => {
        logout();
        setDropdownOpen(false);
    };

    const handleContactUsNavigation = () => {
        navigate('/contact');
    };

    const handleProfileNavigation = () => {
        navigate('/profile');
    };

    const handleSubscribeNavigation = () => {
        navigate('/subscribe');
    };

    const startAssessment = () => {
        setShowModal(true); // Show modal on clicking "Start New"
    };

    const closeModal = () => {
        setShowModal(false); // Close modal
    };

    const agreeAndStart = () => {
        setShowModal(false); // Close modal
        localStorage.removeItem('lastQuestionIndex');
        localStorage.removeItem('surveyResponses');
        window.location.href = '/customer';
    };

    const resumeAssessment = () => {
        window.location.href = '/customer';
    };

    return (
        <div
            style={{
                backgroundImage: `url("${mainBackground}")`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                height: '100vh',
                width: '100vw',
                backgroundColor: '#f0f0f0',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            {/* Transparent Navbar */}
            <nav
    style={{
        position: 'fixed', // Fixed positioning
        top: '0', // Stick to the top of the viewport
        left: '0', // Stick to the left of the viewport
        right: '0', // Ensure full width
        zIndex: '1000', // Ensure it's above other elements
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: '10px 20px',
        background: 'transparent', // Fully transparent background
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)', // Subtle shadow to ensure visibility
    }}
>
    <div>
        {/* Contact Us Button */}
        <button
            style={{
                background: 'none',
                border: 'none',
                padding: '0',
                margin: '0 10px',
                cursor: 'pointer',
            }}
            onClick={handleContactUsNavigation}
        >
            <FaEnvelope size={20} style={{ color: 'black' }} />
        </button>

        {/* Subscribe Button */}
        <button
            style={{
                background: 'none',
                border: 'none',
                padding: '0',
                margin: '0 10px',
                cursor: 'pointer',
            }}
            onClick={handleSubscribeNavigation}
        >
            <FaBell size={20} style={{ color: 'black' }} />
        </button>

        {/* Profile Button */}
        <button
            style={{
                background: 'none',
                border: 'none',
                padding: '0',
                margin: '0 10px',
                cursor: 'pointer',
            }}
            onClick={handleProfileNavigation}
        >
            <FaUser size={20} style={{ color: 'black' }} />
        </button>
    </div>
</nav>


            {/* Welcome Card */}
            <div
    style={{
        backgroundColor: '#dfffd6', // Light green
        padding: '25px',
        borderRadius: '10px',
        textAlign: 'center',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        position: 'relative', // Adjusted for centering
        margin: '60px auto 0 auto', // Adds a 50px margin at the top
        right: '20%',
        maxWidth: '400px',
    }}
>

                {customer ? (
                    <h1 style={{ fontSize: '1.5rem', marginBottom: '10px' }}>
                        Welcome, {customer.name}!
                    </h1>
                ) : (
                    <h1 style={{ fontSize: '1.5rem', marginBottom: '10px' }}>
                        Welcome to ReThinkPack
                    </h1>
                )}
                <p style={{ marginBottom: '20px', fontSize: '16px', color: '#555' }}>
                    Get Started With Your Sustainable Packaging Assessment
                </p>
                <button
                    onClick={startAssessment}
                    style={{
                        margin: '10px 5px',
                        padding: '10px 20px',
                        backgroundColor: '#007bff',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                    }}
                >
                    Start New
                </button>
                <button
                    onClick={resumeAssessment}
                    style={{
                        margin: '10px 5px',
                        padding: '10px 20px',
                        backgroundColor: '#007bff',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                    }}
                >
                    Resume
                </button>
                {error && (
                    <p style={{ color: 'red', marginTop: '10px', fontSize: '14px' }}>{error}</p>
                )}
            </div>

            {/* Modal */}
            {showModal && (
                <div
                    style={{
                        position: 'fixed',
                        top: '0',
                        left: '0',
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: '1000',
                    }}
                >
                    <div
                        style={{
                            background: 'white',
                            padding: '20px',
                            borderRadius: '10px',
                            maxWidth: '500px',
                            width: '90%',
                            textAlign: 'center',
                        }}
                    >
                        <h2 style={{ marginBottom: '15px', fontSize: '20px', fontWeight: 'bold' }}>
                            Disclaimer
                        </h2>
                        <p
                            style={{
                                fontSize: '14px',
                                lineHeight: '1.5',
                                color: '#555',
                                marginBottom: '20px',
                            }}
                        >
The information and recommendations provided herein regarding the assessment of sustainable packaging solutions and country-specific legal requirements for sustainable packaging are intended for general informational purposes only. While efforts have been made to ensure accuracy, completeness, and relevance, the content is not a substitute for professional or legal advice. We do not accept any responsibility for errors, omissions, or misinterpretations in the provided information The legal and regulatory landscape surrounding sustainable packaging varies across jurisdictions and may change over time. It is the responsibility of the individual or organization to verify and ensure compliance with all applicable laws, regulations, and standards in their specific location or market. Any action taken based on the provided information is done at your own risk. We are not liable for any direct, ndirect, or consecuential losses arising from the one of this assessment and recommendations.

Cormult with appropriate legal, environmental, or regulatory experts to ensure full compliance with local and international packaging laws and sustainability quidelines                        </p>
                        <button
                            onClick={agreeAndStart}
                            style={{
                                padding: '10px 20px',
                                border: 'none',
                                borderRadius: '5px',
                                backgroundColor: '#4caf50',
                                color: 'white',
                                cursor: 'pointer',
                                fontSize: '16px',
                            }}
                        >
                            I Agree
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CustomerDashboard;
